module.exports = ".row{\r\n    padding:20px;\r\n}\r\n\r\n\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/not-alloted-list/not-alloted-list.component.css
// module id = ./src/app/allocation/not-alloted-list/not-alloted-list.component.css
// module chunks = main